import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const OrderConfirmation = ({ orderData }) => {
  const orderNumber = 'ORD-2024-001234';
  const estimatedDelivery = 'Tomorrow, 9:00 AM - 11:00 AM';
  const total = 19.45;

  return (
    <div className="max-w-2xl mx-auto text-center space-y-8">
      {/* Success Icon */}
      <div className="flex justify-center">
        <div className="w-20 h-20 bg-success rounded-full flex items-center justify-center">
          <Icon name="CheckCircle" size={40} color="white" />
        </div>
      </div>

      {/* Success Message */}
      <div>
        <h2 className="font-heading font-heading-bold text-2xl text-text-primary mb-2">
          Order Placed Successfully!
        </h2>
        <p className="text-text-secondary">
          Thank you for your order. We'll send you a confirmation email shortly.
        </p>
      </div>

      {/* Order Details */}
      <div className="bg-background rounded-card p-6 text-left">
        <h3 className="font-heading font-heading-semibold text-lg text-text-primary mb-4">
          Order Details
        </h3>
        
        <div className="space-y-3">
          <div className="flex justify-between">
            <span className="text-text-secondary">Order Number</span>
            <span className="font-data font-data-medium text-text-primary">
              {orderNumber}
            </span>
          </div>
          
          <div className="flex justify-between">
            <span className="text-text-secondary">Total Amount</span>
            <span className="font-data font-data-medium text-primary">
              ${total.toFixed(2)}
            </span>
          </div>
          
          <div className="flex justify-between">
            <span className="text-text-secondary">Estimated Delivery</span>
            <span className="font-data font-data-medium text-text-primary">
              {estimatedDelivery}
            </span>
          </div>
          
          <div className="flex justify-between">
            <span className="text-text-secondary">Delivery Address</span>
            <span className="font-data font-data-medium text-text-primary text-right">
              123 Main Street<br />
              New York, NY 10001
            </span>
          </div>
        </div>
      </div>

      {/* Next Steps */}
      <div className="bg-primary/5 border border-primary/20 rounded-card p-6">
        <h3 className="font-heading font-heading-semibold text-lg text-text-primary mb-4">
          What's Next?
        </h3>
        
        <div className="space-y-3 text-left">
          <div className="flex items-start space-x-3">
            <Icon name="Mail" size={20} className="text-primary mt-0.5" />
            <div>
              <p className="font-body-semibold text-text-primary">
                Confirmation Email
              </p>
              <p className="text-text-secondary text-sm">
                You'll receive an order confirmation email within 5 minutes
              </p>
            </div>
          </div>
          
          <div className="flex items-start space-x-3">
            <Icon name="Package" size={20} className="text-primary mt-0.5" />
            <div>
              <p className="font-body-semibold text-text-primary">
                Order Preparation
              </p>
              <p className="text-text-secondary text-sm">
                Our team will carefully prepare your order for delivery
              </p>
            </div>
          </div>
          
          <div className="flex items-start space-x-3">
            <Icon name="Truck" size={20} className="text-primary mt-0.5" />
            <div>
              <p className="font-body-semibold text-text-primary">
                Out for Delivery
              </p>
              <p className="text-text-secondary text-sm">
                You'll receive tracking updates via SMS and email
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <Link to="/homepage-dashboard">
          <Button variant="primary" className="w-full sm:w-auto">
            Continue Shopping
          </Button>
        </Link>
        
        <Button variant="outline" className="w-full sm:w-auto">
          Track Order
        </Button>
      </div>

      {/* Support */}
      <div className="text-center">
        <p className="text-text-secondary text-sm mb-2">
          Need help with your order?
        </p>
        <div className="flex justify-center space-x-4 text-sm">
          <a href="#" className="text-primary hover:underline">
            Contact Support
          </a>
          <span className="text-border">|</span>
          <a href="#" className="text-primary hover:underline">
            FAQ
          </a>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmation;